import { render, staticRenderFns } from "./minipautaTurma.vue?vue&type=template&id=3c7a8db6&"
import script from "./minipautaTurma.vue?vue&type=script&lang=js&"
export * from "./minipautaTurma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports